import { default as Base } from '../services/services.Utils.js';
import { default as Utils } from '../utils/base.Utils.js';


export default class Stats extends Base {

  static get baseUrl() { return Utils.Configuration.baseUrl + Utils.Configuration.statsService; }

  static get idDomainQueryStringParam() {
    const iddomain = Utils.Cookie.get('iddomain');
    if(!!iddomain)
      return '&IDDomain=' + iddomain;
    return '';
  }
  static get singleIdDomainQueryStringParam() {
    const iddomain = Utils.Cookie.get('iddomain');
    if(!!iddomain)
      return '?IDDomain=' + iddomain;
    return '';
  }

  // static get singleIdDomainQueryStringParam() {
  //   const iddomain = Utils.Cookie.get('iddomain');
  //   if(!!iddomain)
  //     return '?IDDomain=' + 648;
  //   return '';
  // }

  constructor() {
    super();
  }

  //Daily*************************************************************************
  static getDayMapStatsByShift(jsonData) {
    // {
    //   "IDMap": "",
    //   "day": ,
    //   "shift": ,
    // }
    return super.doTheCall(null, { type: "GET", url: Stats.baseUrl + "/getDayMapStatsByShift?IDMap="+jsonData.IDMap+"&day="+jsonData.day+"&shift=" + jsonData.shift + Stats.idDomainQueryStringParam}, false);
  }
  static getDayMapStats(jsonData) {
    // {
    //   "IDMap": "",
    //   "day": 
    // }
    return super.doTheCall(null, { type: "GET", url: Stats.baseUrl + "/getDayMapStats?IDMap="+jsonData.IDMap+"&day="+jsonData.day + Stats.idDomainQueryStringParam}, false);
  }  
  static getDayMapCheckinStats(jsonData){
    // {
    //   "IDMap": "",
    //   "day": 
    // }
    return super.doTheCall(null, { type: "GET", url: Stats.baseUrl + "/getDayMapCheckinStats?IDMap="+jsonData.IDMap+"&day="+jsonData.day + Stats.idDomainQueryStringParam}, false);     
  }
  static getDayMapDelete(jsonData){
    // {
    //   "IDMap": "",
    //   "day": 
    // }
    return super.doTheCall(null, { type: "GET", url: Stats.baseUrl + "/getDayMapDelete?IDMap="+jsonData.IDMap+"&day="+jsonData.day + Stats.idDomainQueryStringParam}, false);     
  }
  static getDayMapDeleteDetail(jsonData){
    // {
    //   "IDMap": "",
    //   "day": 
    // }
    return super.doTheCall(null, { type: "GET", url: Stats.baseUrl + "/getDayMapDeleteDetail?IDMap="+jsonData.IDMap+"&day="+jsonData.day + Stats.idDomainQueryStringParam}, false);
    //return Promise.resolve(fakeJson);
  }
  // End Daily*************************************************************************
  
  //Weekly and Month *************************************************************************
  static getPeriodMapStatsByShift(jsonData) {
    // {
    //   "IDMap": "",
    //   "from": ,
    //   "to": ,
    //   "shift": ,
    // }
    return super.doTheCall(null, { type: "GET", url: Stats.baseUrl + "/getPeriodMapStatsByShift?IDMap="+jsonData.IDMap+"&from=" +jsonData.from+"&to=" +jsonData.to+"&shift=" + jsonData.shift + Stats.idDomainQueryStringParam}, false);
  }
  static getPeriodMapStats(jsonData) {
    // {
    //   "IDMap": "",
    //   "from": 
    //   "to": 
    // }
    return super.doTheCall(null, { type: "GET", url: Stats.baseUrl + "/getPeriodMapStats?IDMap="+jsonData.IDMap +"&from="+jsonData.from +"&to=" +jsonData.to+ Stats.idDomainQueryStringParam}, false);
  }    
  static getPeriodMapCheckinStats(jsonData) {
    // {
    //   "IDMap": "",
    //   "from": 
    //   "to": 
    // }
    return super.doTheCall(null, { type: "GET", url: Stats.baseUrl + "/getPeriodMapCheckinStats?IDMap="+jsonData.IDMap +"&from="+jsonData.from +"&to=" +jsonData.to+ Stats.idDomainQueryStringParam}, false);
  }    
  static getPeriodMapDelete(jsonData) {
    // {
    //   "IDMap": "",
    //   "from": 
    //   "to": 
    // }
    return super.doTheCall(null, { type: "GET", url: Stats.baseUrl + "/getPeriodMapDelete?IDMap="+jsonData.IDMap +"&from="+jsonData.from +"&to=" +jsonData.to + "&type=" + jsonData.type + Stats.idDomainQueryStringParam}, false);
  }      

  static getPeriodMapDeleteDetail(jsonData) {
    // {
    //   "IDMap": "",
    //   "from": 
    //   "to": 
    // }
    return super.doTheCall(null, { type: "GET", url: Stats.baseUrl + "/getPeriodMapDeleteDetail?IDMap="+jsonData.IDMap +"&from="+jsonData.from +"&to=" +jsonData.to + "&type=" + jsonData.type + Stats.idDomainQueryStringParam}, false);
    //return Promise.resolve(fakeJson);
  }    
  // End Weekly*************************************************************************

  static getCustomerMapPermission(IDCustomer) {
    // {
    //   "IDMap": "",
    //   "from": 
    //   "to": 
    // }
    return super.doTheCall(null, { type: "GET", url: Stats.baseUrl + "/getCustomerMapPermission?IDCustomer="+ IDCustomer}, false);
  }    

  // Hr Facilities
  static getPeriodMapTopDesks(jsonData) {
    // {
    //   "IDMap": "",
    //   "from": 
    //   "to": 
    //   "numResults"
    // }
  return super.doTheCall(null, { type: "GET", url: Stats.baseUrl + "/getPeriodMapTopDesks?IDMap="+jsonData.IDMap +"&from="+jsonData.from +"&to=" +jsonData.to +"&numResults=" +jsonData.numResults+ Stats.idDomainQueryStringParam}, false);
  }
 


  
  static getPeriodMapTopUsers(jsonData) {
    // {
    //   "IDMap": "",
    //   "from": 
    //   "to": 
    //   "numResults"
    // }
  return super.doTheCall(null, { type: "GET", url: Stats.baseUrl + "/getPeriodMapTopUsers?IDMap="+jsonData.IDMap +"&from="+jsonData.from +"&to=" +jsonData.to +"&numResults=" +jsonData.numResults+ Stats.idDomainQueryStringParam}, false);
  }

  //Heatmap
  static getPeriodMapHeatmap(jsonData) {
    // {
    //   "IDMap": "",
    //   "from": 
    //   "to": 
    // }
    return super.doTheCall(null, { type: "GET", url: Stats.baseUrl + "/getPeriodMapHeatmap?IDMap="+jsonData.IDMap +"&from="+jsonData.from +"&to=" +jsonData.to+"&type="+jsonData.type+"&parkingType="+jsonData.parkingType+ Stats.idDomainQueryStringParam}, false);
  }    



  static getWorkingState(jsonData){
 // {
    //   "IDDomain": "",
    //   "IDCustomer":"",
    //   "dtFrom":"",
    //   "dtTo":""
    // }
    return super.doTheCall(null, { type: "GET", url: Stats.baseUrl + "/getWorkingState?IDCustomer="+jsonData.IDCustomer+"&dtFrom="+jsonData.dtFrom+"&dtTo="+jsonData.dtTo + Stats.idDomainQueryStringParam});     
  }
    //Histogram
  static getPeriodMapWeekDayStats(jsonData) {
    // {
    //   "IDMap": "",
    //   "from": 
    //   "to": 
    // }
    return super.doTheCall(null, { type: "GET", url: Stats.baseUrl + "/getPeriodMapWeekDayStats?IDMap="+jsonData.IDMap +"&from="+jsonData.from +"&to=" +jsonData.to+ Stats.idDomainQueryStringParam}, false);
  }    

  static getCustomersWorkingStateStats(jsonData){
    // {
    //   "IDDomain": "",
    //   "IDCustomer":"",
    //   "dtFrom":"",
    //   "dtTo":"",
    // }
    return super.doTheCall(null, { type: "GET", url: Stats.baseUrl + "/getCustomersWorkingStateStats?IDCustomer="+jsonData.IDCustomer+"&dtFrom="+jsonData.dtFrom+"&dtTo="+jsonData.dtTo+ Stats.idDomainQueryStringParam});     
   
  }
  //Export excel stats TM
  static getTimeManagementList(jsonData) {
    // {
    //   "IDCustomer":"",
    //   "from": 
    //   "to": 
    //   "language:"
    // }
    return super.doTheCall(null, { type: "GET", url: Stats.baseUrl + "/getTimeManagementList?IDCustomer="+jsonData.IDCustomer +"&from="+jsonData.from +"&to=" +jsonData.to+ Stats.idDomainQueryStringParam +"&language=" +jsonData.language, contentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",dataType:"excel"}, false);  
  }    

  static getTMCustomer(){
      return super.doTheCall(null, { type: "GET", url: Stats.baseUrl + "/getTMCustomer"+ Stats.singleIdDomainQueryStringParam}, false);
      //return super.doTheCall(null, { type: "GET", url: 'http://127.0.0.1:3005/stats' + "/getTMCustomer"+ Stats.singleIdDomainQueryStringParam}, false);
  }    
  //   static getTMCustomer(jsonData){
  //   return super.doTheCall(null, { type: "GET", url: Stats.baseUrl + "/getTMCustomer?IDDomain=439"}, false);
  // } 
  // static getTMCustomer(jsonData){
  //   return super.doTheCall(null, { type: "GET", url: Stats.baseUrl + "/getTMCustomer?IDDomain=0"}, false);
  // }    
  
    
  static getTMDayStatsByShift(jsonData) {
    // {    
    //   "company": 
    //   "department": 
    //   "day"
    //   "shift"
    //   "language"
    // }
  return super.doTheCall(null, { type: "GET", url: Stats.baseUrl + "/getTMDayStatsByShift" + Stats.singleIdDomainQueryStringParam +"&company="+jsonData.company +"&department="+jsonData.department +"&day="+jsonData.day+"&shift=" + jsonData.shift +"&language=" +jsonData.language}, false);              
   }

   static getTMDayOfficeStatsByShift(jsonData) {
    // {    
    //   "company": 
    //   "department": 
    //   "day"
    //   "shift"
    //   "workingState"
    //   "language"
    // }
  return super.doTheCall(null, { type: "GET", url: Stats.baseUrl + "/getTMDayOfficeStatsByShift" + Stats.singleIdDomainQueryStringParam +"&company="+jsonData.company+"&serviceLocation="+jsonData.serviceLocation +"&department="+jsonData.department +"&day="+jsonData.day+"&shift=" + jsonData.shift +"&language=" +jsonData.language + "&workingState=" +jsonData.workingState}, false);              
   }  

    static getTMPeriodStatsByShift(jsonData) {
    // {    
    //   "company": 
    //   "department": 
    //   "from"
    //   "to"
    //   "shift"
    //   "language"
    // }
      return super.doTheCall(null, { type: "GET", url: Stats.baseUrl + "/getTMPeriodStatsByShift" + Stats.singleIdDomainQueryStringParam +"&company="+jsonData.company+"&serviceLocation="+jsonData.serviceLocation +"&department="+jsonData.department +"&from="+jsonData.from+ "&to="+jsonData.to+"&shift=" +jsonData.shift +"&language=" +jsonData.language}, false);              
    }

    static getTMPeriodStatsByShiftWorkingState(jsonData) {
      // {    
      //   "company": 
      //   "department": 
      //   "from"
      //   "to"
      //   "shift"      
      //   "workingState"
      // }
      return super.doTheCall(null, { type: "GET", url: Stats.baseUrl + "/getTMPeriodStatsByShiftWorkingState" + Stats.singleIdDomainQueryStringParam +"&company="+jsonData.company +"&department="+jsonData.department +"&from="+jsonData.from+ "&to="+jsonData.to+"&shift=" +jsonData.shift + "&workingState=" +jsonData.workingState}, false);   
    }
      
    static getTMPeriodStatsByWorkingStateTopUsers(jsonData) {
      // {    
      //   "company": 
      //   "department": 
      //   "from"
      //   "to"            
      //   "workingState"
      //   "numResults"
      // }      
      return super.doTheCall(null, { type: "GET", url: Stats.baseUrl + "/getTMPeriodStatsByWorkingStateTopUsers" + Stats.singleIdDomainQueryStringParam +"&company="+jsonData.company+"&serviceLocation="+jsonData.serviceLocation +"&department="+jsonData.department +"&from="+jsonData.from+ "&to="+jsonData.to +"&numResults=" +jsonData.numResults + "&workingState=" +jsonData.workingState}, false);        
      
    }

    //Get last job run
    static getJobLastRun() {
        return super.doTheCall(null, { type: "GET", url: Stats.baseUrl + "/getJobLastRun"}, false);  
    }

    static getAllCustomersTree() {
      return super.doTheCall(null, { type: "GET", url: Stats.baseUrl + "/getAllCustomersTree?IDCustomer=" + App.currentCustomer.ID + Stats.idDomainQueryStringParam}, false);
    }
    
    //Export excel
    static getDeskReservationList(jsonData) {
      // {
      //   "IDMap": "",
      //   "from": 
      //   "to": 
      // }
      return super.doTheCall(null, { type: "GET", url: Stats.baseUrl + "/getDeskReservationList?IDMap="+jsonData.IDMap +"&from="+jsonData.from +"&to=" +jsonData.to+ Stats.idDomainQueryStringParam +"&language=" +jsonData.language, contentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",dataType:"excel"}, false);  
    }

    static getParkingReservationList(jsonData) {
      /*
      {
        IDMap: this.selectedMap.ID,
        from: moment(this.selectedStart).format('YYYY-MM-DD'),
        to: moment(this.selectedStart).format('YYYY-MM-DD'),
        language: Utils.Language.getUserLanguage() == 'it' ? 'it' : 'en',
      }
      */
     return super.doTheCall(null, { type: "GET", url: Stats.baseUrl + "/getParkingReservationList?IDMap="+jsonData.IDMap +"&from="+jsonData.from +"&to=" +jsonData.to+ Stats.idDomainQueryStringParam +"&language=" +jsonData.language, contentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",dataType:"excel"}, false);  
    }

    static getReservationList(jsonData) {
      /*
      {
        IDMap: this.selectedMap.ID,
        from: moment(this.selectedStart).format('YYYY-MM-DD'),
        to: moment(this.selectedStart).format('YYYY-MM-DD'),
        language: Utils.Language.getUserLanguage() == 'it' ? 'it' : 'en',
        type: desk/room/parking
      }
      */
     return super.doTheCall(null, { type: "GET", url: Stats.baseUrl + "/getReservationList?IDMap="+jsonData.IDMap +"&from="+jsonData.from +"&to=" +jsonData.to+ Stats.idDomainQueryStringParam +"&language=" +jsonData.language +"&type="+jsonData.type, contentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",dataType:"excel"}, false);  
    }

    static getPresenceByRole(jsonData) {
      return super.doTheCall(null, { 
        type: "GET", 
        url: Stats.baseUrl + "/getPresenceByRole?IDMap="+jsonData.IDMap +"&from="+jsonData.from +"&to=" +jsonData.to+ Stats.idDomainQueryStringParam +"&IDRole=" +jsonData.role,
        }, false
      );  
    }

    static getCompanyRoles(jsonData) {
      return super.doTheCall(null, { 
        type: "GET", 
        url: Stats.baseUrl + "/getCompanyRoles?language=" + jsonData.language + Stats.idDomainQueryStringParam,
        }, false
      );  
    }
    
    static getRoomList(jsonData) {
      return super.doTheCall(null, {
        type: "GET",
        url: Stats.baseUrl + "/getRoomList?FromDate=" + jsonData.FromDate + "&ToDate=" + jsonData.ToDate + "&POIList=" + jsonData.POIList + Stats.idDomainQueryStringParam
        }, false
      );
    }

    static getRoomDeleted(jsonData) {
      return super.doTheCall(null, {
        type: "GET",
        url: Stats.baseUrl + "/getRoomDeleted?FromDate=" + jsonData.FromDate + "&ToDate=" + jsonData.ToDate + "&POIList=" + jsonData.POIList + Stats.idDomainQueryStringParam
        }, false
      );
    }

    static getRoomDeletedDetail(jsonData) {
      return super.doTheCall(null, {
        type: "GET",
        url: Stats.baseUrl + "/getRoomDeletedDetail?FromDate=" + jsonData.FromDate + "&ToDate=" + jsonData.ToDate + "&POIList=" + jsonData.POIList + Stats.idDomainQueryStringParam
        }, false
      );
    }

    static getRoomBookingsByRange(jsonData) {
      return super.doTheCall(null, {
        type: "GET",
        url: Stats.baseUrl + "/getRoomBookingsByRange?FromDate=" + jsonData.FromDate + "&ToDate=" + jsonData.ToDate + "&POIList=" + jsonData.POIList + "&RangeStart=" + jsonData.RangeStart + "&RangeEnd=" + jsonData.RangeEnd + Stats.idDomainQueryStringParam
        }, false
      );
    }

    static getRoomBookingsByDates(jsonData) {
      return super.doTheCall(null, {
        type: "GET",
        url: Stats.baseUrl + "/getRoomBookingsByDates?FromDate=" + jsonData.FromDate + "&ToDate=" + jsonData.ToDate + "&POIList=" + jsonData.POIList +  Stats.idDomainQueryStringParam
        }, false
      );
    }

    static getRoomTopUsers(jsonData) {
      return super.doTheCall(null, {
        type: "GET",
        url: Stats.baseUrl + "/getRoomTopUsers?FromDate=" + jsonData.FromDate + "&ToDate=" + jsonData.ToDate + "&POIList=" + jsonData.POIList + "&NumResults=" + jsonData.NumResults + Stats.idDomainQueryStringParam
        }, false
      );
    }
    
}

